import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { JobsPage } from './_dashboard.devices.jobs'

export const Route = createFileRoute('/_dashboard/devices/jobs/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: JobsItemPage,
})

function JobsItemPage() {
  const { item } = Route.useParams()
  return <JobsPage selectedId={item} />
}
